export const getOrderItemOptionLabel = (item: any) =>
  item.optionName?.trim() || item.option?.name?.trim() || '';

export const stripTrailingOptionSuffix = (
  value: string,
  optionLabel: string,
) => {
  let result = value.trim();
  const optionSuffix = optionLabel ? ` (${optionLabel})` : '';

  while (optionSuffix && result.endsWith(optionSuffix)) {
    result = result.slice(0, -optionSuffix.length).trim();
  }

  return result;
};

export const getOrderItemBaseName = (
  item: any,
  fallbackName = '상품 정보 없음',
) => {
  const optionLabel = getOrderItemOptionLabel(item);
  const productName = item.product?.name?.trim();
  const itemName = item.name?.trim();
  const baseName = productName || itemName || fallbackName;

  return optionLabel
    ? stripTrailingOptionSuffix(baseName, optionLabel) || baseName
    : baseName;
};

export const getOrderItemDisplayName = (
  item: any,
  fallbackName = '상품 정보 없음',
) => {
  const baseName = getOrderItemBaseName(item, fallbackName);
  const optionLabel = getOrderItemOptionLabel(item);

  return optionLabel ? `${baseName} (${optionLabel})` : baseName;
};

export const getOrderItemAggregationKey = (
  item: any,
  fallbackName = '상품 정보 없음',
) =>
  [
    item.productId || getOrderItemBaseName(item, fallbackName),
    item.productOptionId || getOrderItemOptionLabel(item),
    item.price || 0,
  ].join('::');
